import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesResellers } from "../../constants";
import { ResellerReferralsResponse } from "../../resellers.types";
import { GetResellerReferralsRequestParams } from "./getResellerReferrals.types";

export const requestGetResellerReferrals = async (
  resellerId: string,
  params: GetResellerReferralsRequestParams
): Promise<ResellerReferralsResponse> => {
  return await instance.get(
    buildUrl(
      ApiRoutesResellers.Reseller,
      resellerId,
      ApiRoutesResellers.ResellerReferrals
    ),
    { params }
  );
};
